import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "star"]
  static values = {
    rating: Number
  }

  connect() {
    this.updateStars(this.ratingValue)
  }

  setRating(event) {
    const rating = parseInt(event.currentTarget.dataset.rating)
    this.ratingValue = rating
    this.inputTarget.value = rating
    this.updateStars(rating)
  }

  hoverRating(event) {
    const rating = parseInt(event.currentTarget.dataset.rating)
    this.updateStars(rating, true)
  }

  resetRating() {
    this.updateStars(this.ratingValue)
  }

  updateStars(rating, isHover = false) {
    this.starTargets.forEach((star, index) => {
      const starRating = index + 1
      if (starRating <= rating) {
        star.classList.add("filled")
        star.classList.add("text-amber-500")
        star.classList.remove("text-surface-300", "dark:text-surface-600")
        star.innerText = "star"
      } else {
        star.classList.remove("filled")
        star.classList.remove("text-amber-500")
        star.classList.add("text-surface-300", "dark:text-surface-600")
        star.innerText = "star"
      }
    })
  }
}
